import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './AirbackInfoPageContainer.scss';
import * as queryString from 'query-string';
import { AIRBACK_INFO_TEXTS } from '../lib/consts';
import sendErrorToBot from '../lib/sendErrorToBot';
const icon = require('../assets/no_requests.svg');

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface AirbackInfoPageContainerState {
    service: string;
    tariff: string;
    type: string;
    isVisibleSelector: boolean;
    isSendingError: boolean;
}

export class AirbackInfoPageContainer extends React.Component<RouteProps, AirbackInfoPageContainerState> {
    state = {
        service: '',
        tariff: '',
        type: '',
        isVisibleSelector: false,
        isSendingError: false
    };
    //
    // helpStringToArray = (text: string) => {
    //     const strArray = text.split('\n \n');
    //     // @ts-ignore
    //     let objArray: [
    //         {
    //             title: string;
    //             text: string;
    //         }
    //     ] = [];
    //     strArray.map(str => {
    //         const index = str.indexOf('\n');
    //         objArray.push(
    //             {
    //                 title: str.substring(0, index),
    //                 text: str.substring(index + 1)
    //             });
    //     });
    //     // JSON.stringify(objArray).split('},{').join('},\n{');
    // }

    componentDidMount() {
        const {history} = this.props;
        if (history.location.pathname) {
            const type = history.location.pathname.replace('/', '');
            if (type && type === 'lounges_rules') {
                this.setState({
                    type: 'business_lounges',
                    isVisibleSelector: true
                });
            } else {
                this.setState({type});
            }
        }
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            if (params.service) {
                this.setState({service: params.service});
            }
            if (params.tariff) {
                this.setState({tariff: params.tariff});
            }
        }
    }

    sendError() {
        const {service, tariff, type} = this.state;
        sendErrorToBot('Airback Info', `Service: ${service}\nTariff: ${tariff}\nType: ${type}\n📱Device: ${navigator.userAgent}`);
        this.setState({isSendingError: true});
    }

    render() {
        const {service, tariff, type, isVisibleSelector, isSendingError} = this.state;
        let infoTexts = type
            ? AIRBACK_INFO_TEXTS.find(info =>
                !!tariff && info.tariff === tariff && info.type === type || (!tariff && info.type === type && !!service && info.service === service))
            : [];
        if (!infoTexts && type && (!!service || !!tariff)) {
            infoTexts = AIRBACK_INFO_TEXTS.find(info => info.tariff === 'mts');
        }
        if (!infoTexts && type && type === 'k24-mobile/airback_info') {
            infoTexts = AIRBACK_INFO_TEXTS.find(info => info.type === 'k24-mobile/airback_info');
        }
        const texts = infoTexts ? (infoTexts as any).text : undefined;
        if (type && (!infoTexts || !texts) && !isSendingError) {
            this.sendError();
        }
        if (type && (!infoTexts || !texts) && !isSendingError || isSendingError) {
            return (
                <div className='search-result__wrapper_error'>
                    <img src={icon} />
                    <div className='search-result__group'>
                        <div className='not-found' style={{textAlign: 'center'}}>
                            Страница не найдена
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={`airback-info-container ${tariff} ${service}`}>
                {isVisibleSelector && <div
                    className={`tabs ${service || tariff}`}
                    style={{
                        border: 'none',
                        paddingBottom: 24
                }}
                >
                    <div className='tabs-wrapper'>
                        <div
                            className={`tab-item left ${type === 'business_lounges' ? 'active' : ''}`}
                            onClick={() => type !== 'business_lounges' && this.setState({type: 'business_lounges'})}
                        >
                            Россия
                        </div>
                        <div
                            className={`tab-item right ${type === 'dragon_pass' ? 'active' : ''}`}
                            onClick={() => type !== 'dragon_pass' && this.setState({type: 'dragon_pass'})}
                        >
                            Мир
                        </div>
                    </div>
                </div>}
                {texts && texts.map((text, i) => <div
                    className='airback-info-container__block'
                    key={i}
                >
                    <b>
                        {text.title}
                    </b>
                    <div dangerouslySetInnerHTML={{__html: text.text.split('\n').join('<br/>')}}/>
                </div>)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/K24Mobile/AirbackInfoPageContainer.tsx